import { notice, check, toast } from "react-interaction";

export const setToaster = (value) => {
  // QA (Testing rows 5/7): 2s was too short to read — give toasts 5s.
  toast(value, { time: 5000 });
};

export const checkConform = async (callback, message) => {
  try {
    const isConfirmed = await check(message, {
      okStyle: {
        backgroundColor: "#0078ff",
        color: "#fff",
      },
      contentClassName: "account-logout",
      contentStyle: {
        width: 600,
      },
      okText: "Yes",
      cancelClassName: "my-check-cancel",
      cancelStyle: {
        backgroundColor: "#ccc",
        color: "#fff",
      },
      cancelText: "No",
    });

    if (isConfirmed) {
      callback();
    }
  } catch (error) {
    console.log(error.message);
  }
};

const handleOkClick = () => {
  console.log("OK button clicked!");
};

export const showToaster = (value) => {
  return notice(value, {
    time: 4000,
    okStyle: {
      backgroundColor: "#0e81e4",
      fontSize: 18,
      color: "#fff",
    },

    okText: "OK",
  });
};

export const showToasterWithOk = (value) => {
  return notice(value, {
    // QA rows 5/7: no auto-dismiss — the message stays until OK is pressed.
    okStyle: {
      backgroundColor: "#0e81e4",
      fontSize: 18,
      color: "#fff",
    },
    okText: "OK",
  });
};

export const showMessageBox = (value) => {
  return notice(value, {
    okStyle: {
      backgroundColor: "#0e81e4",
      fontSize: 18,
      color: "#fff",
    },
    okText: "OK",
  });
};

export const renderTitle = (title) => {
  if (!title) {
    return "";
  } else {
    var str = title;
    var n = str.length;
    if (n === 0) {
      return "";
    } else {
      var res = str.slice(0, 30);
      var dot = "";
      if (n > 30) {
        dot = "...";
      }
      return res + dot;
    }
  }
};

export const catchError = (response) => {
  if (response instanceof Error) {
    throw new Error(response.response.data.message);
  }
};

export const UCWords = (title) => {
  if (!title) {
    return "";
  } else {
    // split string on spaces
    var str = title;
    var arrStr = str.split(" ");

    var strOut = [];

    for (var i = 0; i < arrStr.length; i++) {
      // split string
      var firstChar = arrStr[i].substring(0, 1);
      var remainChar = arrStr[i].substring(1);

      // convert case
      firstChar = firstChar.toUpperCase();
      remainChar = remainChar.toLowerCase();

      strOut += firstChar + remainChar + " ";
    }

    // return string, but drop the last space
    return strOut.substring(0, strOut.length - 1);
  }
};

export const showErrorToaster = (value) => {
  notice(value, {
      time: 4000,
      okStyle: {
      backgroundColor: "#ef4343",
      fontSize: 18,
      color: "#fff",
      },

      okText: "OK",
  });
};

export const blobToFile = (theBlob, fileName) => {       
  return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
}

const offAccount = (v) => {
  if (v === 0 || v === "0" || v === false || v === "false") return true;
  if (v === 2 || v === "2") return true;
  const s = String(v).toLowerCase();
  return s === "inactive" || s === "deleted" || s === "disabled";
};
const onFlag = (v) => v === 1 || v === "1" || v === true || v === "true";

/** API account flag: 0 = deleted or inactive, 1 = active. */
const isStatusOff = (v) => {
  if (v === undefined || v === null || v === "") return null;
  if (v === 0 || v === "0" || v === false || v === "false") return true;
  const s = String(v).toLowerCase();
  if (s === "inactive" || s === "deleted" || s === "disabled") return true;
  if (v === 1 || v === "1" || v === true || v === "true") return false;
  return offAccount(v);
};

// Counterpart on Current/Past mentees and My Mentors is still listed after
// admin delete/inactivate; deleted rows come back blank. Prefer
// mentee_status / mentor_status from the relationship APIs (0 = off, 1 = on).
export const isAccountInactive = (item, role = "mentee") => {
  if (!item) return false;
  const statusKey = role === "mentor" ? "mentor_status" : "mentee_status";
  const fromApi = isStatusOff(item[statusKey]);
  if (fromApi === true) return true;

  const name = role === "mentor" ? item.mentor_name : item.mentee_name;
  if (name == null || String(name).trim() === "") return true;

  const prefix = role === "mentor" ? "mentor" : "mentee";
  const keys = [
    `${prefix}_is_deleted`,
    `${prefix}_deleted`,
    `is_${prefix}_deleted`,
    `${prefix}_deleted_at`,
    `${prefix}_is_active`,
    `is_${prefix}_active`,
    `${prefix}_active`,
    `${prefix}_inactive`,
    `is_${prefix}_inactive`,
    `${prefix}_user_status`,
    `${prefix}_account_status`,
    "is_deleted",
    "is_inactive",
    "user_status",
  ];
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (!Object.prototype.hasOwnProperty.call(item, key)) continue;
    const v = item[key];
    if (v == null || v === "") continue;
    if (key.indexOf("deleted_at") !== -1) return true;
    if (key.indexOf("deleted") !== -1) {
      if (onFlag(v)) return true;
      continue;
    }
    if (key.indexOf("inactive") !== -1) {
      if (onFlag(v) || String(v).toLowerCase() === "inactive") return true;
      continue;
    }
    if (key.indexOf("active") !== -1) {
      if (offAccount(v)) return true;
      continue;
    }
    if (offAccount(v)) return true;
  }
  return false;
};

export const counterpartDisplayName = (item, role = "mentee") => {
  const name = role === "mentor" ? item?.mentor_name : item?.mentee_name;
  if (name && String(name).trim()) return name;
  return "Deleted user";
};

export const splitCsv = (v) => {
  if (!v) return [];
  if (Array.isArray(v)) {
    return v
      .map((x) => {
        if (x == null) return "";
        if (typeof x === "string" || typeof x === "number") return String(x);
        return x.title || x.name || x.label || "";
      })
      .map((s) => String(s).trim())
      .filter((s) => s && s !== "undefined");
  }
  return String(v)
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s && s !== "undefined");
};

export const menteeCountryFlag = (item) =>
  (item &&
    (item.mentee_country_image_path ||
      item.country_image_path ||
      item.mentee_country_image ||
      item.country_image)) ||
  "";

export const menteeCountryName = (item) =>
  (item && (item.country_name || item.mentee_country || item.country)) || "";

export const menteeLanguage = (item) => {
  if (!item) return "";
  const hidden =
    item.language_privacy === true ||
    item.language_privacy === 1 ||
    item.language_privacy === "1" ||
    item.mentee_language_privacy === true ||
    item.mentee_language_privacy === 1 ||
    item.mentee_language_privacy === "1";
  if (hidden) return "";
  return splitCsv(
    item.mantee_language ||
      item.mentee_language ||
      item.mentee_languages ||
      item.language ||
      item.languages
  ).join(", ");
};

export const menteeExperience = (item) =>
  splitCsv(
    item?.experience_levels ||
      item?.mentee_experience_levels ||
      item?.experience_level ||
      item?.mentee_experience
  ).join(", ");
